import { NodeListReq, TreatmentNodesDef } from "../type/node-def";

export class TreatmentNodesAdapter {
  static toInputDTO(req: NodeListReq): any {
    return {
      is_past_look: req.is_past_look,
      ...(req.asset_id && { asset_id: req.asset_id }),
      ...(req.outcome_node && { outcome_node: req.outcome_node }),
    };
  }

  static toOutputDTO(data: any): TreatmentNodesDef {
    return {
      treatment_columns: data.treatment_columns?.map((node: any) => ({
        name: node.name,
        value: node.value,
        lag_time_quarter_day: node.lag_time_quarter_day,
        lag_time_one_day: node.lag_time_one_day,
        lag_time_one_week: node.lag_time_one_week,
        lag_time_one_month: node.lag_time_one_month,
        variable_type: node.variable_type
      })) || []
    };
  }
}